export enum VideoListingPageType {
  Staff,
  Students,
  Kids
}

export enum VideoListingFullPageType {
  Category,
  Saved
}